<template>
  <div>
    <NavbarPublicEducational />

    <div class="page-wrapper full-page" style="margin-top: 72px">
      <div
        class="page-content d-flex justify-content-between"
        style="max-width: 1440px; margin: auto; width: 92%"
      >
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavbarPublicEducational from "@/components/public/NavbarPublicEducational.vue";
import { checkAuthUser } from "@/utils/checkAuth";

export default {
  components: {
    NavbarPublicEducational,
  },
  data() {
    return {
      userAgent: {},
      isMenuOpen: false,
    };
  },

  async created() {
    await this.checkAreaAccess();

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    sleep: function (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    handleResize() {
      this.userAgent = this.$root.getUserAgentDetails();
    },
    async checkAreaAccess() {
      this.$store.commit("readUserToken");
      if (this.$store.state.userToken) {
        const authResponse = await checkAuthUser(
          "/v2/users/auth/validate",
          this.$store.state.userToken
        );

        this.sleep(100).then(() => {
          if (authResponse.status) {
            this.$store.state.userDetails = authResponse.data;
            this.$store.commit("setUserToken", this.$store.state.userToken);
            const redirect = this.$route.query.redirect;
            if (redirect) {
            } else {
            }
          } else {
            this.$store.commit("clearUserToken");
          }
        });
      } else {
        this.$store.commit("clearUserToken");
      }
    },
  },

  mounted() {
    this.handleResize();
  },
};
</script>


<style scoped>
</style>